import React, { useState, useEffect } from "react";
import axios from "axios";

import { useForm, Controller, control, NavLink } from "react-hook-form";
import Select, { StylesConfig }  from "react-select";
import {Input, Button, Box, Stack, AppBar, styled, Toolbar,Typography, InputBase,Avatar } from "@mui/material";
import { theme, Badge, } from "@material-ui/core";
import  HomeOutlinedIcon  from "@mui/icons-material/HomeOutlined";
import chroma from 'chroma-js';
import { StyledBox, StyledInput, StyledSelect, TXTRoundedDiv} from "../globalComponents/FormComponents.jsx"
import useMediaQuery from "@mui/material/useMediaQuery";
//import Header from "../../components/Header.jsx";
//import sendDataToAPI from '../../methods/sendDataToAPIs.jsx';

import { DatePicker, Space } from 'antd';
/***
import Contacts from "../../scenes/contacts/index.jsx";
import itemNavLink from "../form/itemNavLink.jsx";
import TableCMAA from "../form/TableCMAA.jsx";
import TableXDataGrid from "../form/TableXDataGrid.jsx";
***/
import { SaveImgToAPIUrl, URL as MYURL } from "../../form/constants";



export default function EditProjectCategoryForm({props}) {
  const [ProjectCategoryName, setProjectCategoryName] = useState('');
  const [PicIntro, setPicIntro] = useState("");
  const [WebIntro, setWebIntro] = useState("");
  const [image, setImage] = useState(null);
  const [posts, setPosts] = useState([]);
  const [call, setCall] = useState(true);
  const [PicFile, setPicFile]=useState();
  const [ServiceCategory, setServiceCategory]=useState({})
  const [afterSubmit, setAfterSubmit]=useState(false);
  const [picsId, setPicsId]=useState(0);

  const [ formData, setFormData]= useState({
    service_category: '',
    name: '',
    pic_intro: '',
    intro_txt: '',
    status: '',
  })
  
  const handleChangeSelect = (e) =>{
    const {name, value } =e
    setFormData({
     ...formData,
     [name]: e.id
    })
    //
    console.log("name=" + formData.name);
    console.log("pic_intro=" + formData.pic_intro);
    console.log("intro_txt=" + formData.intro_txt);
    setServiceCategorySelected({value: e.value, id:e.id, name:e.name, label:e.label})
    console.log("ServiceCategorySelected=" + ServiceCategorySelected);
    //
    setAfterSubmit(false);
  }
 
 const handleChangeInput = (e) =>{
   const {name, value } =e.target
   setFormData({
    ...formData,
    [name]: value
   })
   //
   console.log("name=" + formData.name);
   console.log("pic_intro=" + formData.pic_intro);
   console.log("intro_txt=" + formData.intro_txt);
   //
   setErrors({});
   setAfterSubmit(false);
 }
  
  useEffect(() => {
    axios.get(SaveImgToAPIUrl).then((result) => setPosts(result.data));
    console.log("Hi there");
    console.log(posts.length);
  }, [call]);

  const handleProjectCategoryName = (e) => {
    
    console.log("e.target.value=" + e.target.value)
    setProjectCategoryName(e.target.value);
    console.log("ProjectCategoryName=" + ProjectCategoryName)
    e.preventDefault();
  };


  const handleImage = (e) => {
    e.preventDefault();
    console.log(e.target.files);
    setImage(e.target.files[0]);
    setPicFile(URL.createObjectURL(e.target.files[0]));
    setErrors({});
  };
  
  const [errors, setErrors]=useState({})
  
  const validateForm = (data, imageData) =>{
     const errors= {}
     
     console.log("data.service_category='" + data.service_category + "'");
     
     if(!(data.service_category.toString()).trim()){
       errors.service_category='Please select service category'
     }
     if(!(data.name.toString()).trim()){
      errors.name='Please enter project name'
    }
    if(!(data.pic_intro.toString()).trim()){
      errors.pic_intro='Please select pic intro'
    }
    if(!(data.intro_txt.toString()).trim()){
      errors.intro_txt='Please select web intro'
    }

    if(!(imageData)){
      errors.image='Please select image'
    }
     return errors;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    
    let newErrors=validateForm(formData, image)
    setErrors(newErrors);
     
    setAfterSubmit(true);

    if(Object.keys(newErrors).length===0){
      console.log(ProjectCategoryName, PicIntro, image);
      
      let form_data = new FormData();
      form_data.append("img", image, image.name);
      
      
      let url = SaveImgToAPIUrl;
      //let picsId=0;
      axios
        .post(url, form_data, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("after SaveImgToAPIUrl res.data=" + res.data);
          console.log("res.data['id']=" + res.data['id']);
          setPicsId(res.data['id']);
        })
        .finally(() => {
          setImage(null);
          if(picsId>0){
            
            formData.status=picsId
            let statusobj='status';
            /***
            setFormData({
              ...formData,
              [statusobj]: picsId
            })
            ***/
           }
      
        })
        .catch((err) => console.log("ERROR=" + err));
    }
    else{
    }
  };

  useEffect(()=>{
    console.log();
    if ((formData.status.length) === 0){
       //postImageProjectDetails(picsId);
    }
    else{
      postImageProjectDetails(picsId);
      console.log("XXX formData.status=" + formData.status);
    }
    
  },[formData])
  
  const postImageProjectDetails = ()=>{
    let xURL='/myapi/postPrimaryProjectCategory';
    console.log("ServiceCategory['id']=" + ServiceCategory['id']);
    console.log("QWEE picsId=" + picsId);
    
    //let formDataN= new FormData(formData);
    //formDataN.append({'status': picsId})
    
    
    console.log("formData.status='" + formData.status + "'");
    /*
    let bodyData={
     'service_category': ServiceCategory['id'],
     'name': ProjectCategoryName,
     'pic_intro': PicIntro,
     'intro_txt': WebIntro,
     'status': picsId
    };
    */
    //return;
    let headerOptions={
     method: 'POST',
     headers: {'Content-Type': 'application/json'},
     body: JSON.stringify(formData)
    };
    
    fetch(xURL, headerOptions)
    .then( response=> response.json())
    .then ( json => console.log("FROM SERVER 2" + json))


  }
    //PTXTRoundedDiv=TXTRoundedDiv
    //PStyledBox=StyledBox
    //
    
    //
   
    const colourStyles = {
      
    }
    
    //
    //
   
    //
     const tableXDataGridColumns =[
 
     ]
    //
    
     
    const node = document.querySelector("#app");

    const changeDate = (jsDate, dateString) => {
      // ...
    };
    
    

    /***
    ***/
    /** **/
    
    const tOPButtonOnClick = () =>{
       if(showForm==true){
        setShowForm(false)
        setTopButtonLabel('Show Form')
       }
       else{
        setShowForm(true)
        setTopButtonLabel('Show Records')
       }
    }
    const [showForm, setShowForm] = useState(true);
    const [topButtonLabel, setTopButtonLabel]=useState('Show Records');
     
      const [ServiceCategoryList, setServiceCategoryList ]=useState([{}]);
      
      const customStyles = {
        option: (base, { data, isDisabled, isFocused, isSelected }) => {
        return {
          ...base,
          backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
        };
      }
    };
    
    function loadServiceCategory(data){
      console.log("data=" + data);
      let newData=[];
      newData.push({ 'value': 'Select Service Category', 'label': 'Select Service Category', 'id': 0});
      
      
      data.map(function(data){
        newData.push({ 'value': data.name, 'label': data.name, 'id': data.id, 'name': 'service_category'});
        console.log("data.name=" + data.name);
      })
      
      setServiceCategoryList(newData);
    }
    
    let getProjectCategoryURL="/myapi/ServiceCategoryListView"
    useEffect(()=>{
     
      fetch(getProjectCategoryURL)
      .then( response=> response.json())
      .then( json => loadServiceCategory(json))

    }, [])

    const [ServiceCategorySelected, setServiceCategorySelected]=useState({
      value: '',
      id: '',
      name: '',
      label: ''
    })
  
    return (
      <Box m="20px">
      
      {/** <Button>RECORDS</Button> **/}
     
      
      <br/>
      
      
        <Stack direction="row" spacing={1} justifyContent="space-between">

          <StyledBox flex={4}>
            
            <TXTRoundedDiv>
              <Select
                  name="service_category"
                  placeholder="Service Category"
                  options={ServiceCategoryList}
                  value={ServiceCategorySelected.value}
                  styles={customStyles}
                  /*
                  onChange={(event)=>{
                    console.log("AUDIT=" + event.value);
                    setServiceCategory({value: event.value, label:event.value, id:event.id});
                  }}
                  */
                  onChange={handleChangeSelect}
                  value={ServiceCategory}
              />
              {errors.service_category && (<span>{errors.service_category}</span>)}
            </TXTRoundedDiv>
           
           <TXTRoundedDiv>
           <StyledInput
            name="name"
            type="text"
            placeholder="Project Category Name"
            id="ProjectCategoryName"
            onChange={handleChangeInput}
            //value={ProjectCategoryName}
            //onChange={handleProjectCategoryName}
            
            required
          />
          {errors.name && (<span>{errors.name}</span>)}
           </TXTRoundedDiv>
           
            <TXTRoundedDiv>
            <StyledInput
            type="text"
            name="pic_intro"
            placeholder="Pic Intro"
            id="PicIntro"
            onChange={handleChangeInput}
            //value={PicIntro}
            //onChange={handlePicIntro}
            required />
            {errors.pic_intro && (<span>{errors.pic_intro}</span>)}
            </TXTRoundedDiv>
            
            <TXTRoundedDiv>
            <StyledInput
            name="intro_txt"
            type="text"
            placeholder="Web Intro"
            id="WebIntro"
            onChange={handleChangeInput}
            //value={WebIntro}
            //onChange={handleWebIntro}
            required />
            {errors.intro_txt && (<span>{errors.intro_txt}</span>)}
            </TXTRoundedDiv>

            <TXTRoundedDiv>
            <StyledInput
            type="file"
            id="image"
            accept="image/png,image/jpeg"
            onChange={handleImage}
            required
            />
            {errors.image && (<span>{errors.image}</span>)}
            </TXTRoundedDiv>
            <img src={PicFile}  width={350} height={200} />
           
           <TXTRoundedDiv style={{border: '1px solid #6BD5C0'}}>

           </TXTRoundedDiv>
           
           {/** **/}
             
           
           
          </StyledBox>
          
          <StyledBox flex={4}>    
         

           
           <br>
           
           {/** onChangeDOB */}
           
           {/** <AntdDatePicker getDateFromADP={getDateFromADP} /> **/}

           {/** <Axntd /> **/}
           
          
           </br>
         
        
          </StyledBox>
          
          <StyledBox flex={4}>

          </StyledBox>

        </Stack>
        
        <Stack direction="row" spacing={1} justifyContent="space-between">
        <Box display="flex" justifyContent="end" mt="20px">
              
              {/******/}
              
              <Button type="submit" color="secondary" variant="contained" onClick={handleSubmit}>
                Create Project Category
              </Button>
        </Box>

        </Stack>
        
      </Box>
      
    )
  }